"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FloatingBehaviourComparison = exports.FloatingBehaviourRowSchema = exports.FloatingBehaviourValueSchema = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const z = require("zod");
const value_comparison_1 = require("../../Comparison/value-comparison");
const signal_name_normalization_1 = require("../../DataScience/signal-hygiene/signal-name-normalization");
const comparison_spec_1 = require("../comparison-spec");
exports.FloatingBehaviourValueSchema = z.union([sigma_engine_shared_1.SignalFloatingBehaviorSchema, z.literal('')]);
exports.FloatingBehaviourRowSchema = z.object({
    signalName: z.string(),
    floatingBehaviour: exports.FloatingBehaviourValueSchema,
});
class FloatingBehaviourComparison extends comparison_spec_1.ComparisonSpec {
    constructor() {
        super(...arguments);
        this.alignment = new comparison_spec_1.CellAlignment(['signalName'], ['floatingBehaviour']);
        this.membershipScopeColumns = ['signalName'];
    }
    toRows(data) {
        return data;
    }
    fromRows(rows) {
        return rows;
    }
    rowKeyOf(row) {
        return (0, value_comparison_1.compositeKey)(row, this.alignment.keyColumns.map(String), (column, value, rowContext) => this.normalize(column, value, rowContext));
    }
    normalize(column, value, row) {
        if (column === 'signalName' && typeof value === 'string') {
            return (0, signal_name_normalization_1.normalizeSignalNameForComparison)(value);
        }
        return super.normalize(column, value, row);
    }
    admitsValue(column, value) {
        return column !== 'floatingBehaviour' || value === null || exports.FloatingBehaviourValueSchema.safeParse(value).success;
    }
}
exports.FloatingBehaviourComparison = FloatingBehaviourComparison;
//# sourceMappingURL=floating-behaviour.comparison.js.map